import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  name: () => faker.lorem.words(),
  address: () => faker.location.streetAddress(),
  addressLine1: () => faker.location.streetAddress(),
  addressLine2: () => faker.location.streetAddress(),

  useLocationAddress: true,
  active: true,
});
